// This file is auto-generated during the build process
export const BUILD_VERSION = "20261006-4";
export const BUILD_DATE = "2026-10-06T15:59:59.488Z";
